import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { scrollToId } from "../lib/scroll";

const LINKS = [
  { label: "About", id: "about" },
  { label: "Projects", id: "projects" },
  { label: "Journey", id: "journey" },
  { label: "Beyond the Code", id: "beyond" },
  { label: "Contact", id: "contact" },
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    if (pathname !== "/") {
      navigate("/");
      setTimeout(() => scrollToId(id), 150);
      return;
    }
    scrollToId(id);
  };

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,border-color] duration-500 ${
        scrolled || open
          ? "bg-[#080808]/70 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 h-16 md:h-20 flex items-center justify-between">
        <button
          data-testid="nav-brand"
          onClick={() => go("top")}
          className="font-heading text-base md:text-lg font-medium tracking-tight text-[#F9F9F9] hover:text-[#0EA5E9] transition-colors"
        >
          Virat Chaudhary
        </button>
        <div className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="relative text-sm text-[#A1A1AA] hover:text-[#F9F9F9] transition-colors group"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-[#0EA5E9] transition-[width] duration-300 group-hover:w-full" />
            </button>
          ))}
        </div>
        <button
          data-testid="nav-menu-toggle"
          className="md:hidden text-[#F9F9F9] p-2 -mr-2"
          onClick={() => setOpen(!open)}
          aria-label="Toggle navigation menu"
          aria-expanded={open}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>
      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="md:hidden bg-[#080808]/95 backdrop-blur-xl border-b border-white/10"
        >
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-mobile-link-${l.id}`}
              onClick={() => go(l.id)}
              className="block w-full text-left px-6 py-4 text-[#A1A1AA] hover:text-[#F9F9F9] border-t border-white/5 text-sm transition-colors"
            >
              {l.label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
};
